export const WITHDRAWAL_REQUEST_SUCCESS = 'WITHDRAWAL/REQUEST_SUCCESS'
export const WITHDRAWAL_REQUEST_FAILURE = 'WITHDRAWAL/REQUEST_FAILURE'

export const WITHDRAWAL_TABLE_SUCCESS = 'WITHDRAWAL/TABLE_SUCCESS'
export const WITHDRAWAL_TABLE_FAILURE = 'WITHDRAWAL/TABLE_FAILURE'